
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stores/[slug]",
      function () {
        return require("private-next-pages/stores/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stores/[slug]"])
      });
    }
  